export default "__VITE_ASSET__cffa0260__"